import { useState, forwardRef, useImperativeHandle } from 'react'
import Api from '../../component/Api.js';

const { http } = Api();

const INOChangePssword = forwardRef((props, ref) => {
    const [show, setShow] = useState(false)
    const [INOId, setINOId] = useState(null)
    const [INOUserId, setINOUserId] = useState(null)
    const [INOUserType, setINOUserType] = useState(null)
    const [INOPassword, setINOPassword] = useState('')
    const [INOConfirmPassword, setINOConfirmPassword] = useState('')
    const [INOLoading, setINOLoading] = useState(false)
    const [toast, setToast] = useState(null)
    const [passwordErrors, setPasswordErrors] = useState([])
    const [showPasswordInfo, setShowPasswordInfo] = useState(false)
    const [showPassword, setShowPassword] = useState(false)
    const [showConfirmPassword, setShowConfirmPassword] = useState(false)
    const [passwordMismatch, setPasswordMismatch] = useState(false)

    const showToast = (message, type = 'info') => {
        setToast({ message, type })
        setTimeout(() => setToast(null), 3000)
    }

    const validatePassword = (password) => {
        if (password.length < 8) {
            return ['Password must be at least 8 characters long']
        }

        if (!/^[A-Z]/.test(password)) {
            return ['Password must start with an uppercase letter']
        }

        if (!/[a-z]/.test(password)) {
            return ['Password must contain at least one lowercase letter']
        }

        if (!/\d/.test(password)) {
            return ['Password must contain at least one digit']
        }

        if (!/[\W_]/.test(password)) {
            return ['Password must contain at least one special character']
        }

        return []
    }

    const handlePasswordChange = (e) => {
        const newPassword = e.target.value
        setINOPassword(newPassword)

        if (newPassword && showPasswordInfo) {
            setShowPasswordInfo(false)
        }

        if (newPassword) {
            const errors = validatePassword(newPassword)
            setPasswordErrors(errors)
        } else {
            setPasswordErrors([])
        }

        if (INOConfirmPassword && newPassword !== INOConfirmPassword) {
            setPasswordMismatch(true)
        } else {
            setPasswordMismatch(false)
        }
    }

    const handleConfirmPasswordChange = (e) => {
        const confirmPassword = e.target.value
        setINOConfirmPassword(confirmPassword)

        if (confirmPassword && INOPassword !== confirmPassword) {
            setPasswordMismatch(true)
        } else {
            setPasswordMismatch(false)
        }
    }

    const resetFields = () => {
        setINOPassword('')
        setINOConfirmPassword('')
        setPasswordErrors([])
        setPasswordMismatch(false)
        setShowPasswordInfo(false)
        setShowPassword(false)
        setShowConfirmPassword(false)
    }

    useImperativeHandle(ref, () => ({
        open(id, uid, type) {
            setINOId(id)
            setINOUserId(uid)
            setINOUserType(type)
            resetFields()
            setShow(true)
        }
    }))

    const close = () => {
        setShow(false)
        resetFields()
    }

    const submit = async () => {
        if (!INOPassword || !INOConfirmPassword) {
            showToast('All fields required', 'warning')
            return
        }

        const errors = validatePassword(INOPassword)
        if (errors.length > 0) {
            showToast(errors[0], 'danger')
            return
        }

        if (INOPassword !== INOConfirmPassword) {
            setPasswordMismatch(true)
            showToast('Passwords do not match', 'danger')
            return
        }

        setINOLoading(true)

        try {
            const response = await http.post('/College/changeINOPassword', {
                id: INOId,
                user_id: INOUserId,
                type: INOUserType,
                ino_password:INOPassword,
                confirm_password: INOConfirmPassword
            })

            if (response.data.error || response.data.status === 'error') {
                const errorMessage = response.data.message || response.data.error || 'Password update failed'
                showToast(errorMessage, 'danger')
            } else {
                showToast('Password updated successfully', 'success')
                resetFields()
                setTimeout(() => close(), 1500)
            }
        } catch (error) {
            showToast('Password update failed', 'danger')
        } finally {
            setINOLoading(false)
        }
    }

    if (!show) return null

    return (
        <>
            <div className="modal fade show d-block" tabIndex="-1">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header bg-primary text-white">
                            <h5 className="modal-title">INO Change Password</h5>
                            <button
                                type="button"
                                className="btn btn-link p-0 text-white"
                                onClick={() => setShowPasswordInfo(!showPasswordInfo)}
                                style={{ fontSize: '14px', textDecoration: 'none' }}
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                                    <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z" />
                                </svg>
                            </button>
                        </div>

                        <div className="modal-body">
                            {toast && (
                                <div className={`alert alert-${toast.type} alert-dismissible fade show`} role="alert">
                                    {toast.message}
                                    <button type="button" className="btn-close" onClick={() => setToast(null)}></button>
                                </div>
                            )}

                            <form autoComplete="off" className="mt-3">
                                <input type="hidden" name="user_name" className="form-control mb-2" />
                                <input type="hidden" name="password" className="form-control mb-2" />

                                <div className="mb-2">
                                    <div className="input-group">
                                        <input
                                            type={showPassword ? "text" : "password"}
                                            className={`form-control ${passwordErrors.length > 0 ? 'is-invalid' : ''}`}
                                            placeholder="Enter new password"
                                            autoComplete="new-password"
                                            value={INOPassword}
                                            onChange={handlePasswordChange}
                                        />
                                        <button
                                            type="button"
                                            className="btn border"
                                            onClick={() => setShowPassword(!showPassword)}
                                            style={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}
                                        >
                                            {showPassword ? (
                                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="gray" viewBox="0 0 16 16">
                                                    <path d="M13.359 11.238C15.06 9.72 16 8 16 8s-3-5.5-8-5.5a7.028 7.028 0 0 0-2.79.588l.77.771A5.944 5.944 0 0 1 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.134 13.134 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755-.165.165-.337.328-.517.486l.708.709z" />
                                                    <path d="M11.297 9.176a3.5 3.5 0 0 0-4.474-4.474l.823.823a2.5 2.5 0 0 1 2.829 2.829l.822.822zm-2.943 1.299.822.822a3.5 3.5 0 0 1-4.474-4.474l.823.823a2.5 2.5 0 0 0 2.829 2.829z" />
                                                    <path d="M3.35 5.47c-.18.16-.353.322-.518.487A13.134 13.134 0 0 0 1.172 8l.195.288c.335.48.83 1.12 1.465 1.755C4.121 11.332 5.881 12.5 8 12.5c.716 0 1.39-.133 2.02-.36l.77.772A7.029 7.029 0 0 1 8 13.5C3 13.5 0 8 0 8s.939-1.721 2.641-3.238l.708.709zm10.296 8.884-12-12 .708-.708 12 12-.708.708z" />
                                                </svg>
                                            ) : (
                                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="gray" viewBox="0 0 16 16">
                                                    <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.133 13.133 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5c-2.12 0-3.879-1.168-5.168-2.457A13.134 13.134 0 0 1 1.172 8z" />
                                                    <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z" />
                                                </svg>
                                            )}
                                        </button>
                                    </div>
                                    {passwordErrors.length > 0 && (
                                        <div className="invalid-feedback d-block">
                                            <ul className="mb-0 ps-3">
                                                {passwordErrors.map((error, index) => (
                                                    <li key={index} className="small">{error}</li>
                                                ))}
                                            </ul>
                                        </div>
                                    )}

                                    {showPasswordInfo && (
                                        <div className="card mt-2 border-info" style={{ backgroundColor: '#f8f9fa' }}>
                                            <div className="card-body p-2">
                                                <p className="small text-muted mb-1"><strong>Password Requirements:</strong></p>
                                                <ul className="small text-muted mb-0 ps-3" style={{ fontSize: '12px' }}>
                                                    <li>8-12 characters long</li>
                                                    <li>Must start with an uppercase letter</li>
                                                    <li>At least one lowercase letter</li>
                                                    <li>At least one digit (0-9)</li>
                                                    <li>At least one special character (!@#$%^&*)</li>
                                                </ul>
                                            </div>
                                        </div>
                                    )}
                                </div>

                                <div className="mb-2">
                                    <div className="input-group">
                                        <input
                                            type={showConfirmPassword ? "text" : "password"}
                                            className={`form-control ${passwordMismatch ? 'is-invalid' : ''}`}
                                            placeholder="Confirm Password"
                                            autoComplete="new-password"
                                            value={INOConfirmPassword}
                                            onChange={handleConfirmPasswordChange}
                                        />
                                        <button
                                            type="button"
                                            className="btn border"
                                            onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                            style={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}
                                        >
                                            {showConfirmPassword ? (
                                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="gray" viewBox="0 0 16 16">
                                                    <path d="M13.359 11.238C15.06 9.72 16 8 16 8s-3-5.5-8-5.5a7.028 7.028 0 0 0-2.79.588l.77.771A5.944 5.944 0 0 1 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.134 13.134 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755-.165.165-.337.328-.517.486l.708.709z" />
                                                    <path d="M11.297 9.176a3.5 3.5 0 0 0-4.474-4.474l.823.823a2.5 2.5 0 0 1 2.829 2.829l.822.822zm-2.943 1.299.822.822a3.5 3.5 0 0 1-4.474-4.474l.823.823a2.5 2.5 0 0 0 2.829 2.829z" />
                                                    <path d="M3.35 5.47c-.18.16-.353.322-.518.487A13.134 13.134 0 0 0 1.172 8l.195.288c.335.48.83 1.12 1.465 1.755C4.121 11.332 5.881 12.5 8 12.5c.716 0 1.39-.133 2.02-.36l.77.772A7.029 7.029 0 0 1 8 13.5C3 13.5 0 8 0 8s.939-1.721 2.641-3.238l.708.709zm10.296 8.884-12-12 .708-.708 12 12-.708.708z" />
                                                </svg>
                                            ) : (
                                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="gray" viewBox="0 0 16 16">
                                                    <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.133 13.133 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5c-2.12 0-3.879-1.168-5.168-2.457A13.134 13.134 0 0 1 1.172 8z" />
                                                    <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z" />
                                                </svg>
                                            )}
                                        </button>
                                    </div>
                                    {passwordMismatch && (
                                        <div className="invalid-feedback d-block">
                                            <span className="small">Passwords do not match</span>
                                        </div>
                                    )}
                                </div>

                                <div className="d-flex justify-content-center mt-3">
                                    <button
                                        type="button"
                                        className="btn btn-primary mx-2"
                                        disabled={INOLoading || passwordErrors.length > 0 || passwordMismatch}
                                        onClick={submit}
                                    >
                                        {INOLoading ? 'Updating...' : 'Update'}
                                    </button>

                                    <button type="button" className="btn btn-light" onClick={close}>
                                        Cancel
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>

            <div className="modal-backdrop fade show"></div>
        </>
    )
})

export default INOChangePssword